import { render, staticRenderFns } from "./Performancedeclaration.vue?vue&type=template&id=7d3bffab&scoped=true"
import script from "./Performancedeclaration.vue?vue&type=script&lang=js"
export * from "./Performancedeclaration.vue?vue&type=script&lang=js"
import style0 from "./Performancedeclaration.vue?vue&type=style&index=0&id=7d3bffab&prod&lang=less&scoped=true"
import style1 from "./Performancedeclaration.vue?vue&type=style&index=1&id=7d3bffab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3bffab",
  null
  
)

export default component.exports